import axios from 'axios';
import vm from '@/main';
export function uploadFile(file){
  var promise = new Promise((resolve,reject) => {

    let formData = new FormData();
    formData.append('file', file);

    let fileUrl =  '';
    if(!process.env.VUE_APP_API){
      fileUrl = location.origin +  '/wx/sys/oss/upload';
    }else {
      fileUrl = process.env.VUE_APP_API +  'wx/sys/oss/upload';
    }
    // let fileUrl =  process.env.VUE_APP_API + 'crm/file/upload';
    if(window.location.origin.indexOf('https') > -1 && fileUrl.indexOf('https') == -1){
      fileUrl = fileUrl.replace('http','https');
    }
    let headers = {
      'Content-Type': 'multipart/form-data',
    };
    let tokenX = localStorage.getItem('token');
    if(tokenX){
      headers['token'] = tokenX;
    }
    axios({
      url: fileUrl,
      method: 'post',
      data: formData,
      timeout: 30000,
      headers: headers,
      //{loaded, total, progress, bytes, estimated, rate, upload = true}
      /*onUploadProgress(progressEvent) {
        // Do whatever you want with the Axios progress event
        let persent = (progressEvent.loaded / progressEvent.total * 100 | 0)		//上传进度百分比
        callback(persent);
      },*/
    }).then((res) => {
      console.log(res);
      if(res.data.code !== 200){
        vm.$vs.notify({
          title: '注意',
          text: res.data.msg,
          position: 'top-center',
          color: 'danger',
        });
        return Promise.reject(res.data);
      }
      resolve(res);
    }).catch((err) => {
      reject(err);
    })
  })
  return promise;
};

export function uploadFileOld(formData){
  var promise = new Promise((resolve,reject) => {
    let fileUrl =  '';
    if(!process.env.VUE_APP_API){
      fileUrl = location.origin +  '/wx/manage/wxAssets/materialFileUpload';
    }else {
      fileUrl = process.env.VUE_APP_API +  'wx//manage/wxAssets/materialFileUpload';
    }
    // let fileUrl =  process.env.VUE_APP_API + 'crm/file/upload';
    if(window.location.origin.indexOf('https') > -1 && fileUrl.indexOf('https') == -1){
      fileUrl = fileUrl.replace('http','https');
    }
    let headers = {
      'Content-Type': 'multipart/form-data',
    };
    let tokenX = localStorage.getItem('token');
    if(tokenX){
      headers['token'] = tokenX;
    }
    axios({
      url: fileUrl,
      method: 'post',
      data: formData,
      timeout: 30000,
      headers: headers,
      //{loaded, total, progress, bytes, estimated, rate, upload = true}
      /*onUploadProgress(progressEvent) {
        // Do whatever you want with the Axios progress event
        let persent = (progressEvent.loaded / progressEvent.total * 100 | 0)		//上传进度百分比
        callback(persent);
      },*/
    }).then((res) => {
      resolve(res);
    }).catch((err) => {
      reject(err);
    })
  })
  return promise;
};
